export enum SessionStorage {
  DISCORD_ACTIVITY = "pr_dcd_jwt",
  DISCORD_WEB = "pr_discord_jwt",
  GOOGLE_WEB = "pr_google_jwt",
}

export const GAME_INSTRUCTIONS = [
  {
    id: 1,
    heading: "how_to_play_1",
    description: "how_to_play_1_description",
    img: "img/UI/how-to-1.webp",
  },
  {
    id: 2,
    heading: "how_to_play_2",
    description: "how_to_play_2_description",
    img: "img/UI/how-to-2.webp",
  },
  {
    id: 3,
    heading: "how_to_play_3",
    description: "how_to_play_3_description",
    img: "img/UI/how-to-3.webp",
  },
  
];